"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaysDiff = exports.formatTimeZone = exports.capitalizeFirstLetter = void 0;
const capitalizeFirstLetter = ([first, ...rest], locale) => (first === undefined ? '' : first.toLocaleUpperCase(locale) + rest.join(''));
exports.capitalizeFirstLetter = capitalizeFirstLetter;
const formatTimeZone = (dateTime) => dateTime.toFormat('ZZZZ');
exports.formatTimeZone = formatTimeZone;
// return A - B
const getDaysDiff = (dateTimeA, dateTimeB) => dateTimeA.startOf('day').diff(dateTimeB.startOf('day'), 'days').days;
exports.getDaysDiff = getDaysDiff;
//# sourceMappingURL=utils.js.map